module.exports = __webpack_public_path__ + "img/full7-min.024160a7.png";